.section {
  position: relative;
  z-index: 1;
  padding: 7rem 6vw 6rem;
  overflow: hidden;
}

.bgAccent {
  position: absolute;
  bottom: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(99,210,190,0.06) 0%, transparent 70%);
  pointer-events: none;
}

.inner {
  max-width: 680px;
  margin: 0 auto;
  text-align: center;
}

.eyebrow {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--teal);
  letter-spacing: 0.22em;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.heading {
  font-family: var(--font-display);
  font-size: clamp(2.2rem, 5vw, 4rem);
  font-weight: 900;
  color: var(--white);
  line-height: 1.05;
  letter-spacing: -0.025em;
  margin-bottom: 1.2rem;
}

.accent { color: var(--teal); }

.sub {
  font-size: 1rem;
  color: var(--mist);
  line-height: 1.82;
  margin-bottom: 2.8rem;
}

/* Email block */
.emailBlock {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 3rem;
}

.emailLink {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  background: var(--teal);
  color: var(--ink);
  text-decoration: none;
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 1.05rem;
  letter-spacing: -0.01em;
  padding: 1rem 2.2rem;
  border-radius: 8px;
  transition: background 0.2s, transform 0.15s;
}

.emailLink:hover {
  background: #7ee8d8;
  transform: translateY(-2px);
}

.copyBtn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: rgba(255,255,255,0.25);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  transition: color 0.2s;
}

.copyBtn:hover {
  color: var(--teal);
}

/* Info grid */
.infoGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.infoCard {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.1rem 1.2rem;
  text-align: left;
}

.infoIcon { font-size: 1.3rem; flex-shrink: 0; }

.infoLabel {
  font-family: var(--font-mono);
  font-size: 0.62rem;
  color: var(--mist);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.infoValue {
  font-family: var(--font-display);
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--white);
}

@media (max-width: 640px) {
  .section { padding: 5rem 5vw 4rem; }
  .infoGrid { grid-template-columns: 1fr; }
  .emailLink { font-size: 0.85rem; padding: 0.85rem 1.4rem; }
}
